import styled from "@emotion/styled";
import React from "react";
import { baseInputCss, baseInputIosFixCss } from "./Question";
import QuestionWrapper from "./QuestionWrapper";

const StyledQuestionSelect = styled.select`
  ${baseInputCss}
  ${baseInputIosFixCss}
`;

function QuestionSelect(
  props: React.ComponentPropsWithRef<typeof StyledQuestionSelect> & {
    children: React.ReactNode;
    className?: string;
  },
  ref: React.Ref<HTMLSelectElement>
) {
  const { children, ...rest } = props;
  return (
    <QuestionWrapper>
      <StyledQuestionSelect role="combobox" {...rest} ref={ref}>
        {children}
      </StyledQuestionSelect>
    </QuestionWrapper>
  );
}

export default Object.assign(React.forwardRef(QuestionSelect), {
  Option: styled.option``,
});
